// extracted by mini-css-extract-plugin
export default {"moneyContainer":"Money_moneyContainer__XGDNA","active":"Money_active__zadgx"};